<template>
    <div
            class="map-info overflow-y-scroll"
            style="pointer-events: all;"
            @click.stop="$emit('hide')"
        >
            <div class="map-info-container map-info-content" style="max-height: 40vh">
                <span class="tip" style="color: #00eaff !important;">{{ $t('common.click_to_hide') }}</span>
                <div class="row p-2">
                    <div class="col-sm-6" style="border-right: #BEFF41 1px solid">
                        <div v-for="(item, index) in firstColumn" :key="index" class="row">
                            <div class="col-sm-6 data-title">
                                {{ item.title }}
                            </div>
                            <div class="col-sm-6 data-value">
                                {{ item.value }}
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div v-for="(item, index) in secondColumn" :key="index" class="row">
                            <div class="col-sm-6 data-title">
                                {{ item.title }}
                            </div>
                            <div class="col-sm-6 data-value">
                                {{ item.value }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'RoadInfo',
    props: {
        roadInfo: {
            type: Array,
            required: true
        },
        map: {
            type: Object,
            required: true
        },
        coords: {
            type: Object,
            required: true
        }
    },

    computed: {
        dataMid() {
            return Math.round(this.roadInfo.length / 2)
        },
        firstColumn() {
            return this.roadInfo.slice(0, this.dataMid)
        },
        secondColumn() {
            return this.roadInfo.slice(this.dataMid)
        }
    },

    watch: {
        coords: function() {
            this.drawMarker()
        }
    },

    mounted: function () {
        this.drawMarker()
    },

    beforeUnmount() {
        this.hideMarker()
    },

    methods: {
        drawMarker() {
            this.map.showMapMarker(99, this.ROAD, this.coords.lat, this.coords.lng)
        },

        hideMarker() {
            this.map.removeMapMarker(99, this.ROAD)
        }
    }
}
</script>
<style scoped>
.data-title {
    color: #BEFF41 !important;
    font-size: .9em;
    font-weight: bold;
    text-transform: uppercase;
    text-shadow: 1px 1px #000000;
}

.data-value {
    color: #FFFFFF;
    font-weight: bold;
    text-shadow: 1px 1px #000000;
}

</style>
